import { Box, Button, Grid, IconButton, Typography, useMediaQuery } from '@material-ui/core';
import { createStyles, makeStyles, Theme, useTheme } from '@material-ui/core/styles';
import React, { useEffect, useState } from 'react';
import * as yup from 'yup';
import { RegularSizeValue, RegularSizeValueShortName } from 'common-ts/dist/models/Cart';
import { useAppDispatch, useAppSelector } from '../reduxhooks';
import OverlayComponentBaseContainerHorizontal from './OverlayComponentBaseContainerHorizontal';
import OverlayComponentBaseContainerWidth from './OverlayComponentBaseContainerWidth';
import OverlayComponentButton, { FareastButton, FareastButtonGrey } from './OverlayComponentButton';
import OverlayComponentChoice from './OverlayComponentChoice';
import OverlayComponentForm from './OverlayComponentForm';
import OverlayComponentBaseTemplate from './OverlayComponentBaseTemplate';
import OverlayComponentTitle from './OverlayComponentTitle';
import OverlayComponentCanvas, { DrawGuidelinesData } from './OverlayComponentCanvasFitAnimation';
import PageProductOverlayMeasureInstructions from './OverlayViewGenerateMeasureMethod3Favorite1ModifySizePopup';
import { ClothingMeasurementAdjustmentLevel, ClothingMeasurementDetailList, ClothingMeasurementOrdering, 
  ClothingMeasurements, ClothingMeasurementsKey, ClothingType, 
  BodyMeasurements, FitType, CalculateClothingMeasurementsFromBodyMeasurements, RoundClothingMeasurementsToHalfPoint, ClothingMeasurementAdjustmentDisplayRange, GetKey2CategoryClothingSizeMeasurementValues, BodyMeasurementsKey, BodyMeasurementsForSize, 
  DefaultFollowingMeasurementsForClothingTypeAndFitType,
  ClothBodyToDisplayedClothMeasForClothingTypeAndFitType, 
  CalculateClothBodyMeasurementsFromBodyMeasurements,
  ClothingTypeDisplayString,
  CreateBodyContructRangeForKey2,
  GlobalMeasRules,
  hasCuffSizeLabels} from 'common-ts/dist/models/UserMeasurements';
import { openOverlay } from '../redux/UIOverlayMeasureInstructionsRedux';
import { getRequestDataProducts, retryGetRequest } from '../redux/CartRedux';
import { AxiosRequestConfig } from 'axios';
import hash from 'object-hash';
import ZoomOutIcon from '@material-ui/icons/ZoomOut';
import { UIOverlayViewStatus } from 'common-ts/dist/models/UIOverlayViewStatus';
import { getReferenceProductIdForKey2 } from 'common-ts/dist/models/Product';
import RestoreIcon from '@mui/icons-material/RestartAlt';
import Tooltip from '@material-ui/core/Tooltip';
import { formatTimestampSize } from './PageProductDetailSizeSelection';
import EditIcon from '@material-ui/icons/Edit';

interface stylesProps {
  isMinimized: boolean 
}

const useStyles = (({ isMinimized }: stylesProps) => makeStyles((theme: Theme) =>
  createStyles({
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      width: '300px',
      [theme.breakpoints.only('xs')]: {
        width: '240px',
      }
    },
    gridContainer: {
      width: isMinimized ? '90%' : '100%',
      [theme.breakpoints.up('md')]: {
        paddingTop: isMinimized ? '0px' : '0px',
      },
    },
    form: {
      height: 'auto',
      padding: '0px 24px 0px 24px',
      [theme.breakpoints.only('xs')]: {
        padding: '0px 0px 0px 0px',
      }
    },
    formRow: {
      paddingBottom: '30px',
    },
    subFormTitle: {
    },
    toggleSignUpSignInContainer: {
      paddingTop: '30px',
      paddingBottom: '30px',
      // paddingLeft: '10px',
      paddingRight: '10px',
    },
    buttonContainer: {
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      alignItems: "baseline",
      justifyContent: isMinimized ? 'space-between' : 'flex-end',
      width: '100%',
      paddingBottom: '12px',
      [theme.breakpoints.only('xs')]: {
        paddingBottom: '6px',
      }
    },
    canvasContainer: {
      width: '100%',
      height: '100%',
      [theme.breakpoints.only('xs')]: {
        height: '75vw',
      },
      position: 'relative',
    },
    measurementValueContainer: {
      width: '100%',
      height: isMinimized ? '35px' : '40px',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: "baseline",
    },
    measurementNameText: {
      fontSize: isMinimized ? '10.5px' : '12px',
      fontWeight: isMinimized ? 400 : 300,
  
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',

      cursor: "pointer",
      '-webkit-tap-highlight-color': 'transparent',
    },
    measurementNameTextIIcon: {
      fontSize: isMinimized ? '9.5px' : '11px',
      marginLeft: "3px",
    },
    measurementValueTextContainer: {
      width: "50%",
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    measurementValueText: {
      fontFamily: 'Open Sans, sans-serif',
      fontSize: isMinimized ? '10.5px' : '12px',
      fontWeight: 500,
      marginBottom: '0px',
    },
    measurementValueTextSub: {
      fontFamily: 'Open Sans, sans-serif',
      fontSize: isMinimized ? '8px' : '10px',
      fontWeight: isMinimized ? 400 : 300,
      letterSpacing: '0.7px',
      color: '#3e3e3e',
      textWrap: 'nowrap',
      width: '200%'
    },
    measurementChangeValueButton: {
      width: isMinimized ? "20%" : '25%',
      minWidth: "4px",
      padding: "0px",
      '& .MuiButton-label': {
        fontSize: isMinimized ? '15.5px' : '18px',
        fontWeight: 400,
      }
    },
    ukuranCustomAvailText: {
      fontWeight: 500,
      fontSize: isMinimized ? '8.5px' : '11px',
      letterSpacing: '0.05px',
      marginTop: '7px',
      marginBottom: isMinimized ? '-6px' : '-20px',
    }
  }),
));

export function getBodyMeasurementsSubtext(bodyMeasurements: BodyMeasurements) {

  // KEY2TODO-CB Add new CB
  const results: {[key in BodyMeasurementsKey]: string} = {
    panjangBaju: '',
    lingkarDada: '',
    lingkarPerut: '',
    lingkarPinggul: '',
    lingkarLeher: '',
    lebarBahu: '',
    lingkarLenganBisep: '',
    panjangLenganPanjang: '',
    lingkarLenganPergelangan: '',

    // CB
    lebarLenganBawahTigaEmpat: '',
    lebarLenganPendek: '',
    panjangLenganPendek: '',
  }

  const regularSizeNames: RegularSizeValue[] = [
    RegularSizeValue.XXS,
    RegularSizeValue.XS,
    RegularSizeValue.S,
    RegularSizeValue.M,
    RegularSizeValue.L,
    RegularSizeValue.XL,
    RegularSizeValue.XXL,
  ];
  if (true) {
    regularSizeNames.push(RegularSizeValue.XXXL);
    regularSizeNames.push(RegularSizeValue.XXXXL);
    regularSizeNames.push(RegularSizeValue.XXXXXL);
    regularSizeNames.push(RegularSizeValue.XXXXXXL);
    regularSizeNames.push(RegularSizeValue.XXXXXXXL);
    regularSizeNames.push(RegularSizeValue.XXXXXXXXL);
  }

  const sizeMeasNames = regularSizeNames;
  const sizeMeasValues = regularSizeNames.map((keyValue: RegularSizeValue) => BodyMeasurementsForSize[keyValue]);

  for (let bodyMeasName of Object.keys(bodyMeasurements)) {
    const currentBodyMeasValue = bodyMeasurements[bodyMeasName as keyof BodyMeasurements];
    for (var i = 0; i < sizeMeasValues.length; i++) {
      const sizeClothMeasValue = sizeMeasValues[i]?.[bodyMeasName as keyof BodyMeasurements];
      const sizeClothMeasName = sizeMeasNames[i];
      if (!sizeClothMeasValue || !currentBodyMeasValue || !sizeClothMeasName) {
        return results;
      }
      if (currentBodyMeasValue < sizeClothMeasValue) {
        if (i === 0) {
          results[bodyMeasName as keyof BodyMeasurements] = 'Ukuran Baju Dibawah XXS';
        } else {
          results[bodyMeasName as keyof BodyMeasurements] = 'Antara ' + 
            RegularSizeValueShortName[sizeMeasNames[i - 1]] + ' dan ' +
            RegularSizeValueShortName[sizeClothMeasName];
        }
        if (bodyMeasName === 'lingkarLeher') {
          if (RegularSizeValueShortName[sizeClothMeasName] === 'XXS' || 
            RegularSizeValueShortName[sizeClothMeasName] === 'XS' || 
            RegularSizeValueShortName[sizeClothMeasName] === 'S') {
            results[bodyMeasName as keyof BodyMeasurements] = 'Ukuran Kecil (S - M)'
          } else if (RegularSizeValueShortName[sizeClothMeasName] === 'M' ||
            RegularSizeValueShortName[sizeClothMeasName] === 'L') {
            results[bodyMeasName as keyof BodyMeasurements] = 'Ukuran Sedang (M - L)'
          } else if (RegularSizeValueShortName[sizeClothMeasName] === 'XL' ||
            RegularSizeValueShortName[sizeClothMeasName] === 'XXL') {
            results[bodyMeasName as keyof BodyMeasurements] = 'Ukuran Besar (L - XL)'
          } else if (RegularSizeValueShortName[sizeClothMeasName] === '3XL' ||
            RegularSizeValueShortName[sizeClothMeasName] === '4XL' ||
            RegularSizeValueShortName[sizeClothMeasName] === '5XL' ||
            RegularSizeValueShortName[sizeClothMeasName] === '6XL' ||
            RegularSizeValueShortName[sizeClothMeasName] === '7XL' ||
            RegularSizeValueShortName[sizeClothMeasName] === '8XL') {
            results[bodyMeasName as keyof BodyMeasurements] = 'Ukuran Jumbo (XL - XXL)'
          }
        }
        break;
      } else if (currentBodyMeasValue === sizeClothMeasValue) {
        results[bodyMeasName as keyof BodyMeasurements] = 'Ukuran Baju ' +
          RegularSizeValueShortName[sizeClothMeasName];
        if (bodyMeasName === 'lingkarLeher') {
          if (RegularSizeValueShortName[sizeClothMeasName] === 'XXS' || 
            RegularSizeValueShortName[sizeClothMeasName] === 'XS' || 
            RegularSizeValueShortName[sizeClothMeasName] === 'S') {
            results[bodyMeasName as keyof BodyMeasurements] = 'Ukuran Kecil (S - M)'
          } else if (RegularSizeValueShortName[sizeClothMeasName] === 'M' ||
            RegularSizeValueShortName[sizeClothMeasName] === 'L') {
            results[bodyMeasName as keyof BodyMeasurements] = 'Ukuran Sedang (M - L)'
          } else if (RegularSizeValueShortName[sizeClothMeasName] === 'XL' ||
            RegularSizeValueShortName[sizeClothMeasName] === 'XXL') {
            results[bodyMeasName as keyof BodyMeasurements] = 'Ukuran Besar (L - XL)'
          } else if (RegularSizeValueShortName[sizeClothMeasName] === '3XL' ||
            RegularSizeValueShortName[sizeClothMeasName] === '4XL' ||
            RegularSizeValueShortName[sizeClothMeasName] === '5XL' ||
            RegularSizeValueShortName[sizeClothMeasName] === '6XL' ||
            RegularSizeValueShortName[sizeClothMeasName] === '7XL' ||
            RegularSizeValueShortName[sizeClothMeasName] === '8XL') {
            results[bodyMeasName as keyof BodyMeasurements] = 'Ukuran Jumbo (XL - XXL)'
          }
        }
        break;
      }
      if (i === sizeMeasValues.length - 1) {
        results[bodyMeasName as keyof BodyMeasurements] = 'Ukuran Baju Diatas ' + 
        RegularSizeValueShortName[sizeClothMeasName];
      }
    }
  }

  return results;
}

export function getClothingMeasurementsSubtext(clothingType: string, key2ClothSizeValues: {
  regularSizeNames: RegularSizeValue[];
  regularSizeClothMeasValues: ClothingMeasurements[];
  regularSizeClothMeasRawValues: ClothingMeasurements[];
  regularSizeClothBodyMeasValues: BodyMeasurements[];
}, clothingMeasurements: ClothingMeasurements) {
  const results: {[key in ClothingMeasurementsKey]: string } = {
    panjangBaju: '',
    lebarDadaBaju: '',
    lebarPerutBaju: '',
    lingkarLeherBaju: '',
    lebarBahuBaju: '',
    panjangLenganPendek: '',
    panjangLenganPanjang: '',
    lebarLenganBaju: '',
    lebarLenganAtasBaju: '',
  }

  if (key2ClothSizeValues.regularSizeClothMeasValues.length !== key2ClothSizeValues.regularSizeNames.length) {
    return results;
  }

  const sizeMeasNames = key2ClothSizeValues.regularSizeNames;
  const sizeMeasValues = key2ClothSizeValues.regularSizeClothMeasValues;

  for (let clothMeasName of Object.keys(clothingMeasurements)) {
    const currentClothMeasValue = clothingMeasurements[clothMeasName as keyof ClothingMeasurements];
    for (var i = 0; i < sizeMeasValues.length; i++) {
      const sizeClothMeasValue = sizeMeasValues[i]?.[clothMeasName as keyof ClothingMeasurements];
      const sizeClothMeasName = sizeMeasNames[i];
      if (!sizeClothMeasValue || !currentClothMeasValue || !sizeClothMeasName) {
        return results;
      }
      if (currentClothMeasValue < sizeClothMeasValue) {
        if (i === 0) {
          results[clothMeasName as keyof ClothingMeasurements] = 'Dibawah XXS';
        } else {
          results[clothMeasName as keyof ClothingMeasurements] = 'Antara ' + 
            RegularSizeValueShortName[sizeMeasNames[i - 1]] + ' dan ' +
            RegularSizeValueShortName[sizeClothMeasName];
        }
        break;
      } else if (currentClothMeasValue === sizeClothMeasValue) {
        results[clothMeasName as keyof ClothingMeasurements] = 'Ukuran ' +
          RegularSizeValueShortName[sizeClothMeasName];
        if (clothMeasName === 'lingkarLeherBaju') {
          if (RegularSizeValueShortName[sizeClothMeasName] === 'XXS') {
            results[clothMeasName as keyof ClothingMeasurements] = 'Kecil (S - M)'
          } else if (RegularSizeValueShortName[sizeClothMeasName] === 'M') {
            results[clothMeasName as keyof ClothingMeasurements] = 'Sedang (M - L)'
          } else if (RegularSizeValueShortName[sizeClothMeasName] === 'XL') {
            results[clothMeasName as keyof ClothingMeasurements] = 'Besar (L - XL)'
          }
        }
        if (hasCuffSizeLabels(clothingType) && clothMeasName === 'lebarLenganBaju') {
          if (RegularSizeValueShortName[sizeClothMeasName] === 'XXS') {
            results[clothMeasName as keyof ClothingMeasurements] = 'Kecil (S - M)'
          } else if (RegularSizeValueShortName[sizeClothMeasName] === 'M') {
            results[clothMeasName as keyof ClothingMeasurements] = 'Sedang (M - L)'
          } else if (RegularSizeValueShortName[sizeClothMeasName] === 'XL') {
            results[clothMeasName as keyof ClothingMeasurements] = 'Besar (L - XL)'
          }
        }
        break;
      }
      if (i === sizeMeasValues.length - 1) {
        results[clothMeasName as keyof ClothingMeasurements] = 'Diatas ' + 
        RegularSizeValueShortName[sizeClothMeasName];
      }
    }
  }

  return results;
}
export function getClothingMeasurementsRuler(clothingType: string, key2ClothSizeValues: {
  regularSizeNames: RegularSizeValue[];
  regularSizeClothMeasValues: ClothingMeasurements[];
  regularSizeClothMeasRawValues: ClothingMeasurements[];
  regularSizeClothBodyMeasValues: BodyMeasurements[];
}, rawClothingMeasurements: ClothingMeasurements) {
  const results: {[key in ClothingMeasurementsKey]: {
    sizeNamesArray: string[] // ['XXS', 'XS', 'S', ... ]
    sizeValuesArray: number[] // [42, 46, 50, ... ]
    currentValue: number
    clothMeasName: string
  }} = {
    panjangBaju: {sizeNamesArray: [], sizeValuesArray: [], currentValue: 10, clothMeasName: ''},
    lebarDadaBaju: {sizeNamesArray: [], sizeValuesArray: [], currentValue: 10, clothMeasName: ''},
    lebarPerutBaju: {sizeNamesArray: [], sizeValuesArray: [], currentValue: 10, clothMeasName: ''},
    lingkarLeherBaju: {sizeNamesArray: [], sizeValuesArray: [], currentValue: 10, clothMeasName: ''},
    lebarBahuBaju: {sizeNamesArray: [], sizeValuesArray: [], currentValue: 10, clothMeasName: ''},
    panjangLenganPendek: {sizeNamesArray: [], sizeValuesArray: [], currentValue: 10, clothMeasName: ''},
    panjangLenganPanjang: {sizeNamesArray: [], sizeValuesArray: [], currentValue: 10, clothMeasName: ''},
    lebarLenganBaju: {sizeNamesArray: [], sizeValuesArray: [], currentValue: 10, clothMeasName: ''},
    lebarLenganAtasBaju: {sizeNamesArray: [], sizeValuesArray: [], currentValue: 10, clothMeasName: ''},
  }

  if (key2ClothSizeValues.regularSizeClothMeasValues.length !== key2ClothSizeValues.regularSizeNames.length) {
    return results;
  }

  const sizeMeasNames = key2ClothSizeValues.regularSizeNames;
  const sizeMeasValues = key2ClothSizeValues.regularSizeClothMeasRawValues;

  // 1: Round to 1
  // 2: Round to 0.5
  // 5: Round to 0.2
  // 10: Round to 0.1
  // 20: Round to 0.05
  const roundToDict: {[key in ClothingMeasurementsKey]: number} = {
    panjangBaju: 1,
    lebarDadaBaju: 1, // 2
    lebarPerutBaju: 1, // 2
    lingkarLeherBaju: 1,
    lebarBahuBaju: 1,
    panjangLenganPanjang: 1,
    lebarLenganAtasBaju: 10,
    panjangLenganPendek: 10,
    lebarLenganBaju: 10,
  };

  for (let clothMeasName of Object.keys(rawClothingMeasurements)) {

    let roundTo = roundToDict[clothMeasName as keyof ClothingMeasurements];

    const currentClothMeasValue = rawClothingMeasurements[clothMeasName as keyof ClothingMeasurements];
    results[clothMeasName as keyof ClothingMeasurements].sizeNamesArray = sizeMeasNames.map((sizeString) => RegularSizeValueShortName?.[sizeString] ?? 'X');
    results[clothMeasName as keyof ClothingMeasurements].sizeValuesArray = sizeMeasValues.map((sizeMeasValue) => Math.round(roundTo * (sizeMeasValue?.[clothMeasName as keyof ClothingMeasurements] ?? 10)) / roundTo);
    results[clothMeasName as keyof ClothingMeasurements].currentValue = Math.round(roundTo * (currentClothMeasValue ?? 10)) / roundTo;
    results[clothMeasName as keyof ClothingMeasurements].clothMeasName = clothMeasName;
  }

  return results;
}

export const SizeWheelComponent = React.memo(function SizeWheelComponent({sizeNamesArray: sizeNamesArrayRaw, sizeValuesArray: sizeValuesArrayRaw, currentValue, clothMeasName}: {
  // componentType: string // dibawah-XXS | between-M (Between M and L) | middle-M | diatas-XXL
  sizeNamesArray: string[] // ['XXS', 'XS', 'S', ... ]
  sizeValuesArray: number[] // [42, 46, 50, ... ]
  currentValue: number
  clothMeasName: string
}) {

  const [previousState, setPreviousState] = React.useState<{
    componentType: string,
    mainSizeString: string,
    diantaraFirstSizeString: string,
    diantaraSecondSizeString: string,
    diantaraPercent: number,
    tickTock: boolean,
  }>({
    componentType: '',
    mainSizeString: '',
    diantaraFirstSizeString: '',
    diantaraSecondSizeString: '',
    diantaraPercent: 0,
    tickTock: false,
  })
  const [currentState, setCurrentState] = React.useState<{
    componentType: string,
    mainSizeString: string,
    diantaraFirstSizeString: string,
    diantaraSecondSizeString: string,
    diantaraPercent: number,
    tickTock: boolean,
  }>({
    componentType: 'x',
    mainSizeString: 'x',
    diantaraFirstSizeString: 'x',
    diantaraSecondSizeString: 'x',
    diantaraPercent: 0,
    tickTock: true,
  })

  // Recalculate values
  let componentType: 'dibawah' | 'diantara' | 'persis' | 'diatas' = 'persis';
  let mainSizeString: string = 'M';
  let diantaraFirstSizeString: string = 'L';
  let diantaraSecondSizeString: string = 'L';
  let diantaraPercent: number = 50;

  let skipRender = false;

  // 0. Skip duplicates
  const sizeNamesArray = [];
  const sizeValuesArray = [];

  for (let i = 0; i < sizeValuesArrayRaw.length; i = i + 1) {
    if (i === sizeValuesArrayRaw.length - 1) {
      sizeNamesArray.push(sizeNamesArrayRaw[i]);
      sizeValuesArray.push(sizeValuesArrayRaw[i]);
      continue;
    }
    if (sizeValuesArrayRaw[i] === sizeValuesArrayRaw[i + 1]) {
      continue;
    }
    sizeNamesArray.push(sizeNamesArrayRaw[i]);
    sizeValuesArray.push(sizeValuesArrayRaw[i]);
  }

  // 01. Get the current index and status.
  for (let i = 0; i < sizeValuesArray.length; i = i + 1) {
    const sizeClothMeasValue = sizeValuesArray[i];
    if (!sizeClothMeasValue || !currentValue) {
      skipRender = true;
      break;
    }
    if (currentValue < sizeClothMeasValue) {
      if (i === 0) {
        componentType = 'dibawah';
        mainSizeString = '';
        diantaraFirstSizeString = '';
        diantaraSecondSizeString = sizeNamesArray[i];
        diantaraPercent = Math.round(100 * (currentValue - (sizeValuesArray[i] - (sizeValuesArray[i + 1] - sizeValuesArray[i]))) 
        / (sizeValuesArray[i] - sizeValuesArray[i - 1]));
        break;
      } else {
        componentType = 'diantara';
        mainSizeString = '';
        diantaraFirstSizeString = sizeNamesArray[i - 1];
        diantaraSecondSizeString = sizeNamesArray[i];
        diantaraPercent = Math.round(100 * (currentValue - sizeValuesArray[i - 1]) 
          / (sizeClothMeasValue - sizeValuesArray[i - 1]));
        // let snapPercent = clothMeasName === 'lebarDadaBaju' || clothMeasName === 'lebarPerutBaju' ? 14 : 1;
        // if (diantaraPercent < snapPercent) { // "Snap" to nearest size
        //   componentType = 'persis';
        //   mainSizeString = sizeNamesArray[i - 1];
        //   diantaraFirstSizeString = sizeNamesArray?.[i - 2] ?? '';
        //   diantaraSecondSizeString = sizeNamesArray?.[i] ?? '';
        //   diantaraPercent = -1;
        // }
        // if (diantaraPercent > (100 - snapPercent)) { // "Snap" to nearest size
        //   componentType = 'persis';
        //   mainSizeString = sizeNamesArray[i];
        //   diantaraFirstSizeString = sizeNamesArray?.[i - 1] ?? '';
        //   diantaraSecondSizeString = sizeNamesArray?.[i + 1] ?? '';
        //   diantaraPercent = -1;
        // }
        break;
      }
    } else if (currentValue === sizeClothMeasValue) {
      componentType = 'persis';
      mainSizeString = sizeNamesArray[i];
      diantaraFirstSizeString = sizeNamesArray?.[i - 1] ?? '';
      diantaraSecondSizeString = sizeNamesArray?.[i + 1] ?? '';
      diantaraPercent = -1;

      if (clothMeasName === 'lingkarLeherBaju') {
        if (mainSizeString === 'S') {
          mainSizeString = 'S-M';
          diantaraFirstSizeString = '';
          diantaraSecondSizeString = 'M-L';
          diantaraPercent = 0;
        } else if (mainSizeString === 'L') {
          mainSizeString = 'M-L';
          diantaraFirstSizeString = 'S-M';
          diantaraSecondSizeString = 'L-XL';
          diantaraPercent = 0;
        } else if (mainSizeString === 'XXL') {
          mainSizeString = 'L-XL';
          diantaraFirstSizeString = 'M-L';
          diantaraSecondSizeString = '';
          diantaraPercent = 0;
        }
      }
      // if (clothingType === "KemejaPanjang" && clothMeasName === 'lebarLenganBaju') {
      //   if (RegularSizeValueShortName[sizeClothMeasName] === 'XXS') {
      //     results[clothMeasName as keyof ClothingMeasurements] = 'Kecil (S - M)'
      //   } else if (RegularSizeValueShortName[sizeClothMeasName] === 'M') {
      //     results[clothMeasName as keyof ClothingMeasurements] = 'Sedang (M - L)'
      //   } else if (RegularSizeValueShortName[sizeClothMeasName] === 'XL') {
      //     results[clothMeasName as keyof ClothingMeasurements] = 'Besar (L - XL)'
      //   }
      // }
      break;
    }
    if (i === sizeValuesArray.length - 1) {
      componentType = 'diatas';
      mainSizeString = '';
      diantaraFirstSizeString = sizeNamesArray[i];
      diantaraSecondSizeString = '';
      diantaraPercent = Math.round(100 * (currentValue - sizeValuesArray[i]) 
      / (sizeValuesArray[i] - sizeValuesArray[i - 1]));
      break;
    }
  }

  useEffect(() => {
    setPreviousState(currentState);
    setCurrentState(currentState => ({
      componentType: componentType,
      mainSizeString: mainSizeString,
      diantaraFirstSizeString: diantaraFirstSizeString,
      diantaraSecondSizeString: diantaraSecondSizeString,
      diantaraPercent: diantaraPercent,
      tickTock: !currentState.tickTock,
    }));
  }, [componentType, mainSizeString, diantaraFirstSizeString, diantaraSecondSizeString, diantaraPercent]);

  let verticalMarkerLeftValue = Math.max(Math.min(diantaraPercent, 100), 0);
  // console.log(verticalMarkerLeftValue); // To check if memo is working

  if (skipRender) {
    return null;
  }

  // console.log(previousState);
  // console.log(currentState);

  const cssDict = {
    textLeft: {
      top: '-2.5px',
      left: '-11%',
      width: clothMeasName === 'lingkarLeherBaju' ? '30%' : '20%',
      fontSize: '8.1px',
      letterSpacing: '0.2px',
    },
    textMiddle: {
      top: '-2.5px',
      left: clothMeasName === 'lingkarLeherBaju' ? '30%' : '40%',
      width: clothMeasName === 'lingkarLeherBaju' ? '40%' : '20%',
      transform: clothMeasName === 'lingkarLeherBaju' ? 'scale(1.235)' : 'scale(1.36)',
      fontSize: '8.1px',
      letterSpacing: '0.4px',
    },
    textRight: {
      top: '-2.5px',
      left: clothMeasName === 'lingkarLeherBaju' ? '81%' : '91%',
      width: clothMeasName === 'lingkarLeherBaju' ? '30%' : '20%',
      fontSize: '8.1px',
      letterSpacing: '0.2px',
    }
  }

  const transitionWheelTimeIn = 0.6;
  const transitionStringIn = `all ${transitionWheelTimeIn}s ease`;
  const transitionWheelTimeOut = 0.4;
  const transitionStringOut = `all ${transitionWheelTimeOut}s ease`;

  return (
    <Box style={{
      width: '100%',
      position: 'relative'
    }}>
      <div id={'ruler-background'}
      style={{
        backgroundColor: componentType === 'persis' ? '#f8f8f8' : '#eaeaea',
        borderRadius: '10px',
        height: '4.5px',
        marginLeft: '20%',
        width: '60%',
        position: 'relative',
        transition: 'background-color 0.6s ease',
      }}
      >
        <div id={'vertical-marker'}
        style={{
          display: componentType === 'persis' || diantaraPercent === -1 ? 'none' : 'block',
          backgroundColor: componentType === 'persis' || diantaraPercent === -1 ? 'rgba(0,0,0,0)' : '#000',
          borderRadius: '10px',
          width: '2px',
          height: '4.5px',
          position: 'absolute',
          top: '0px',
          left: verticalMarkerLeftValue + '%',
          transition: 'left 0.6s ease, backgroundColor 1s ease',
        }}
        ></div>
      </div>
      <Typography id={'left-text'} style={{
        color: componentType === 'persis' ? '#c0c0c0' : '#000000',
        position: 'absolute',
        top: '-2.5px',
        left: '-11%',
        width: clothMeasName === 'lingkarLeherBaju' ? '30%' : '20%',
        fontSize: '8.1px',
        visibility: previousState.mainSizeString === currentState.diantaraFirstSizeString ? 'hidden' : 'visible',
      }}>
        { diantaraFirstSizeString }
      </Typography> 

      {
        previousState.componentType === 'x'
        || !(currentState.mainSizeString === previousState.diantaraFirstSizeString || currentState.mainSizeString === previousState.diantaraSecondSizeString) ?
        <Typography id={'middle-text-starting'} style={{
          ...cssDict['textMiddle'],
          position: 'absolute',
          color: '#000000',
          visibility: 'visible'
        }}>
          { currentState.mainSizeString }
        </Typography>: undefined
      }

      {/* 
        The current has 2 sets for in, the previous also has 2 sets. 
        There is an issue on the 'persis-persis' animation, so we use a TICKTOCK method to "alternate" the component that is used
        to house the transition. The problem simply is that things can't 'jump', so we just invisible it and use the other set. 
      */}
      <Typography id={'middle-text-side-left-in-1'} style={
        currentState.mainSizeString && currentState.mainSizeString === previousState.diantaraFirstSizeString && currentState.tickTock ? {
          ...cssDict['textMiddle'],

          position: 'absolute',
          transition: transitionStringIn,

          visibility: 'visible',
          color: '#000'
        }: {
          ...cssDict['textLeft'],

          position: 'absolute',
          transition: transitionStringIn,

          visibility: 'visible',
          color: '#000'
        }}>
        { 
          currentState.mainSizeString && currentState.mainSizeString === previousState.diantaraFirstSizeString && currentState.tickTock ? currentState.mainSizeString : ''
        }
      </Typography>
      <Typography id={'middle-text-side-left-in-2'} style={
        currentState.mainSizeString && currentState.mainSizeString === previousState.diantaraFirstSizeString && !currentState.tickTock ? {
          ...cssDict['textMiddle'],

          position: 'absolute',
          transition: transitionStringIn,

          visibility: 'visible',
          color: '#000'
        }: {
          ...cssDict['textLeft'],

          position: 'absolute',
          transition: transitionStringIn,

          visibility: 'visible',
          color: '#000'
        }}>
        { 
          currentState.mainSizeString && currentState.mainSizeString === previousState.diantaraFirstSizeString && !currentState.tickTock ? currentState.mainSizeString : ''
        }
      </Typography>
      <Typography id={'middle-text-side-right-in-1'} style={
        currentState.mainSizeString && currentState.mainSizeString === previousState.diantaraSecondSizeString && currentState.tickTock ? {
          ...cssDict['textMiddle'],

          position: 'absolute',
          transition: transitionStringIn,

          visibility: 'visible',
          color: '#000',
        }: {
          ...cssDict['textRight'],

          position: 'absolute',
          transition: transitionStringIn,

          visibility: 'visible',
          color: '#000'
        }}>
        { 
          currentState.mainSizeString && currentState.mainSizeString === previousState.diantaraSecondSizeString && currentState.tickTock ? currentState.mainSizeString : ''
          }
      </Typography>
      <Typography id={'middle-text-side-right-in-2'} style={
        currentState.mainSizeString && currentState.mainSizeString === previousState.diantaraSecondSizeString && !currentState.tickTock ? {
          ...cssDict['textMiddle'],

          position: 'absolute',
          transition: transitionStringIn,

          visibility: 'visible',
          color: '#000',
        }: {
          ...cssDict['textRight'],

          position: 'absolute',
          transition: transitionStringIn,

          visibility: 'visible',
          color: '#000'
        }}>
        { 
          currentState.mainSizeString && currentState.mainSizeString === previousState.diantaraSecondSizeString && !currentState.tickTock ? currentState.mainSizeString : ''
          }
      </Typography>

      {/* 
        The current has 2 sets for in, the previous also has 2 sets. 
        There is an issue on the 'persis-persis' animation, so we use a TICKTOCK method to "alternate" the component that is used
        to house the transition. The problem simply is that things can't 'jump', so we just invisible it and use the other set. 
      */}
      <Typography id={'middle-text-side-left-out-1'} style={
        previousState.mainSizeString && previousState.mainSizeString === currentState.diantaraFirstSizeString && currentState.tickTock ? {
          ...cssDict['textLeft'],

          position: 'absolute',
          transition: transitionStringOut,

          visibility: 'visible',
          color: (previousState.mainSizeString === currentState.diantaraFirstSizeString && currentState.componentType !== 'persis') ? '#000' : '#c0c0c0'
        }: {
          ...cssDict['textMiddle'],

          position: 'absolute',
          transition: transitionStringIn,

          visibility: 'visible',
          color: '#000'
        }}>
        { 
          previousState.mainSizeString && previousState.mainSizeString === currentState.diantaraFirstSizeString && currentState.tickTock ? 
          previousState.mainSizeString
           : ''}
      </Typography>
      <Typography id={'middle-text-side-left-out-2'} style={
        previousState.mainSizeString && previousState.mainSizeString === currentState.diantaraFirstSizeString && !currentState.tickTock ? {
          ...cssDict['textLeft'],

          position: 'absolute',
          transition: transitionStringOut,

          visibility: 'visible',
          color: (previousState.mainSizeString === currentState.diantaraFirstSizeString && currentState.componentType !== 'persis') ? '#000' : '#c0c0c0'
        }: {
          ...cssDict['textMiddle'],

          position: 'absolute',
          transition: transitionStringIn,

          visibility: 'visible',
          color: '#000'
        }}>
        { 
          previousState.mainSizeString && previousState.mainSizeString === currentState.diantaraFirstSizeString && !currentState.tickTock ? 
          previousState.mainSizeString
           : ''}
      </Typography>
      <Typography id={'middle-text-side-right-out-1'} style={
        previousState.mainSizeString && previousState.mainSizeString === currentState.diantaraSecondSizeString && currentState.tickTock ? {
          ...cssDict['textRight'],

          position: 'absolute',
          transition: transitionStringOut,

          visibility: 'visible',
          color: (previousState.mainSizeString === currentState.diantaraSecondSizeString && currentState.componentType !== 'persis') ? '#000' : '#c0c0c0'
        }: {
          ...cssDict['textMiddle'],

          position: 'absolute',
          transition: transitionStringIn,

          visibility: 'visible',
          color: '#000'
        }}>
        { 
          previousState.mainSizeString && previousState.mainSizeString === currentState.diantaraSecondSizeString && currentState.tickTock ? 
          previousState.mainSizeString
           : ''}
      </Typography>
      <Typography id={'middle-text-side-right-out-2'} style={
        previousState.mainSizeString && previousState.mainSizeString === currentState.diantaraSecondSizeString && !currentState.tickTock ? {
          ...cssDict['textRight'],

          position: 'absolute',
          transition: transitionStringOut,

          visibility: 'visible',
          color: (previousState.mainSizeString === currentState.diantaraSecondSizeString && currentState.componentType !== 'persis') ? '#000' : '#c0c0c0'
        }: {
          ...cssDict['textMiddle'],

          position: 'absolute',
          transition: transitionStringIn,

          visibility: 'visible',
          color: '#000'
        }}>
        { 
          previousState.mainSizeString && previousState.mainSizeString === currentState.diantaraSecondSizeString && !currentState.tickTock ? 
          previousState.mainSizeString
           : ''}
      </Typography>

      <Typography id={'right-text'} style={{
        color: componentType === 'persis' ? '#c0c0c0' : '#000000',
        position: 'absolute',
        top: '-2.5px',
        right: '-11%',
        width: clothMeasName === 'lingkarLeherBaju' ? '30%' : '20%',
        fontSize: '8.1px',
        visibility: previousState.mainSizeString === currentState.diantaraSecondSizeString ? 'hidden' : 'visible',
      }}>
        { diantaraSecondSizeString }
      </Typography>
    </Box>
  )
  
}, ((prevProps, nextProps) => 
  JSON.stringify(prevProps.sizeNamesArray) === JSON.stringify(nextProps.sizeNamesArray) && JSON.stringify(prevProps.sizeValuesArray) === JSON.stringify(nextProps.sizeValuesArray)
  && 
  prevProps.currentValue === nextProps.currentValue && prevProps.clothMeasName === nextProps.clothMeasName
));

export interface ClothingMeasurementsDetailPanelProps {
  clothingType: ClothingType
  fitType: FitType
  allowEditing: boolean
  currentClothingMeas: ClothingMeasurements
  currentClothingMeasSubtextDict: {[key:string]: string}
  currentClothingMeasUpdatedDict?: ClothingMeasurements
  currentBodyMeasRawValue?: BodyMeasurements // REGULAR CLOTHING CALC MAKES THE THING CB-COMPLETE. WE NEED TO PASS THE RAW VALUES AS WELL
  currentlyFetchingAvailability: boolean
  clothMeasActionsDict?: {
    [key: string]: {
      clothMeasInfoFunction: () => void
      minusDetail: {
        onClickFunction: () => void
        isEnabled: boolean
        needsMod: boolean
      }
      plusDetail: {
        onClickFunction: () => void
        isEnabled: boolean
        needsMod: boolean
      }
    }
  }
  isMinimized?: boolean
  isSizeWheel?: boolean
  useInstantATCView?: boolean
  reductionMode?: boolean
  instantAtcViewMinimized?: string
  instantAtcViewMinimizedChange?: (newValue: string) => void
  tailorString?: string
  updateTimestamp?: string
  usePersonalFitSpecificVariableDisplay?: boolean
  sizeWheelDict?: {[key:string]: {
    sizeNamesArray: string[] // ['XXS', 'XS', 'S', ... ]
    sizeValuesArray: number[] // [42, 46, 50, ... ]
    currentValue: number
    clothMeasName: string
  }}
  triggerList?: { // We determine the triggers at the start (as input)
    [key: string]: {
      clothingMeasurementsKey: string // Same as the key for this dictionary
      bodyMeasurementsKey: string,
      triggerText: string
      triggerCallback: () => void
      showMeasurementAs?: 'SIZEWHEEL' | 'NUMBER'
    }
  }
}

const dictOfDisplayedMinimized: {[key: string]: boolean} = {
  'panjangBaju': true,
  'lebarDadaBaju': true,
  'lebarPerutBaju': true
};

// IF BOTH KEY AND VALUE EXIST, WE DISPLAY AS "MANUAL"
const dictOfClothingSpecificVariablesToBodyVariables: {[key: string]: string} = {
  'panjangLenganPendek': 'panjangLenganPendek',
  'lebarLenganBaju': 'lebarLenganPendek',
};

export function convertTimestampToDisplayString(timestamp: string) {
  if (!timestamp) {
    return '-';
  }

  const curTime = new Date().getTime();
  const creationTime = new Date(timestamp).getTime();

  const timeElapsedMs =  curTime - creationTime;
  const timeElapsedS = Math.round(timeElapsedMs / 1000);
  const timeElapsedMinutes = Math.round(timeElapsedMs / (60 * 1000));
  const timeElapsedHours = Math.round(timeElapsedMs / (60 * 60 * 1000));
  const timeElapsedDays = Math.round(timeElapsedMs / (24 * 60 * 60 * 1000));
  const timeElapsedWeeks = Math.round(timeElapsedMs / (7 * 24 * 60 * 60 * 1000));
  const timeElapsedMonthsApprox = Math.round(timeElapsedMs / (30.5 * 24 * 60 * 60 * 1000));
  const timeElapsedYears = Math.round(timeElapsedMs / (365 * 24 * 60 * 60 * 1000));

  if (timeElapsedS < 70) {
    return (timeElapsedS + " detik lalu");
  } else if (timeElapsedMinutes < 60) {
    return (timeElapsedMinutes + " menit lalu");
  } else if (timeElapsedHours < 24) {
    return (timeElapsedHours + " jam lalu");
  } else if (timeElapsedDays === 1) {
    return ("kemarin");
  } else if (timeElapsedDays < 10) {
    return (timeElapsedDays + " hari lalu");
  } else if (timeElapsedWeeks < 5) {
    return (timeElapsedWeeks + " minggu lalu");
  } else if (timeElapsedMonthsApprox < 13) {
    return (timeElapsedMonthsApprox + " bulan lalu");
  } else {
    return (timeElapsedYears + " tahun lalu");
  } 
}

export function ClothingMeasurementDetailPanel({ clothingType, fitType,
  allowEditing, currentClothingMeas, currentClothingMeasSubtextDict, currentClothingMeasUpdatedDict={}, currentBodyMeasRawValue={},
  currentlyFetchingAvailability, clothMeasActionsDict, isMinimized=false, isSizeWheel=false, triggerList, useInstantATCView=false, reductionMode=false,
  instantAtcViewMinimized=undefined, instantAtcViewMinimizedChange=() => {}, tailorString='', updateTimestamp=undefined, usePersonalFitSpecificVariableDisplay=false,
  sizeWheelDict={'ax': {sizeNamesArray: [], sizeValuesArray: [], currentValue: 10, clothMeasName:'sdfa'}}}: ClothingMeasurementsDetailPanelProps) {
  const classes = useStyles({isMinimized: isMinimized})();

  const clothingMeasurementsDisplayed = Object.values(ClothBodyToDisplayedClothMeasForClothingTypeAndFitType[clothingType]);

  const thereIsUpdatedVariable = Object.keys(currentClothingMeasUpdatedDict)?.length > 0;

  if (instantAtcViewMinimized === '3-cartitem') {
    return (
    <Grid container className={classes.gridContainer} style={useInstantATCView ? {width: '100%'} : undefined}
      direction="row" justifyContent="flex-start">
      <Typography style={{fontSize: '7.5px', letterSpacing: '0.3px', fontWeight: 300, color: '#565656', margin: '0px 0px 8px', width: '100%', textAlign: 'center'}}>{(thereIsUpdatedVariable ? "DIUBAH ": "DIBUAT ")}  
        <span style={{textDecoration: 'underline', textUnderlineOffset: '2px'}}><i>{(updateTimestamp ? convertTimestampToDisplayString(updateTimestamp)?.toUpperCase() : '')}</i></span></Typography>
      {
        ClothingMeasurementOrdering.map((itemKey) => {
          let combineLebarBaju = false;
          if (thereIsUpdatedVariable) { // THERE IS UPDATED VARIABLES
            if (!currentClothingMeasUpdatedDict?.[itemKey]) {
              return null;
            }
          } else { // NO UPDATED VARIABLE / FRESH
            if (!dictOfDisplayedMinimized?.[itemKey]) {
              return null;
            }
            // CHECK IF CHEST AND WAIST IS EQUAL
            combineLebarBaju = currentClothingMeas.lebarDadaBaju === currentClothingMeas.lebarPerutBaju;
            // SKIP IF CHEST AND WAIST IS EQUAL AND ITEMKEY IS LEBAR PERUT BAJU
            if (combineLebarBaju && itemKey === ClothingMeasurementsKey.lebarPerutBaju) {
              return null;
            }
          }
          if (!clothingMeasurementsDisplayed.includes(itemKey as ClothingMeasurementsKey)) {
            return null;
          }
          if (currentClothingMeas[itemKey as ClothingMeasurementsKey] === undefined) {
            return null;
          }
          if (ClothingMeasurementDetailList[itemKey as ClothingMeasurementsKey] === undefined
            || ClothingMeasurementAdjustmentLevel[itemKey as ClothingMeasurementsKey] === undefined
            || ClothingMeasurementAdjustmentLevel[itemKey as ClothingMeasurementsKey] === "unavailable") {
            return null;
          }

          let chosenBodyMeasKey: BodyMeasurementsKey | undefined = undefined;
          for (let bodyMeasKey of Object.keys(ClothBodyToDisplayedClothMeasForClothingTypeAndFitType[clothingType])) {
            if (ClothBodyToDisplayedClothMeasForClothingTypeAndFitType[clothingType]?.[bodyMeasKey as BodyMeasurementsKey]
              === itemKey) {
              chosenBodyMeasKey = bodyMeasKey as BodyMeasurementsKey;
            }
          }
          if (chosenBodyMeasKey === undefined) {
            return null;
          }

          const useTrigger = triggerList?.[(itemKey as string)] && triggerList?.[(itemKey as string)].bodyMeasurementsKey === chosenBodyMeasKey;
          const useTriggerAction = useTrigger && triggerList[itemKey].triggerText;
          const useTriggerPresentationNumber = (useTrigger && triggerList[itemKey].showMeasurementAs === "NUMBER") 
          || ((clothingType === ClothingType.Body || usePersonalFitSpecificVariableDisplay) && dictOfClothingSpecificVariablesToBodyVariables[itemKey] && currentBodyMeasRawValue?.[dictOfClothingSpecificVariablesToBodyVariables[itemKey] as BodyMeasurementsKey]); // EITHER TRIGERRED ON CREATION OR SHOWN WHEN WE ARE USING BODY

          const measurementName = ClothingMeasurementDetailList[itemKey as ClothingMeasurementsKey].clothingMeasurementName;
          const measurementNameShort = (combineLebarBaju && itemKey === ClothingMeasurementsKey.lebarDadaBaju) ? "Lebar Baju" : ClothingMeasurementDetailList[itemKey as ClothingMeasurementsKey].clothingMeasurementNameShort;
          const measurementValue = currentClothingMeas[itemKey as keyof ClothingMeasurements] as number;
          return (
            <Grid item xs={12} onClick={() => instantAtcViewMinimizedChange('')} >
              {
                useInstantATCView ? 
                <Box className={classes.measurementValueContainer} style={{
                  height: '19px',
                  display: 'flex',
                  justifyContent: 'space-between',
                  overflowX: 'hidden',
                  overflowY: 'hidden',
                }}>
                  <Box>
                    <Typography className={classes.measurementNameText} style={{color: '#454545', fontSize: '9px'}}
                    onClick={useTriggerAction ? triggerList[itemKey].triggerCallback : clothMeasActionsDict?.[itemKey].clothMeasInfoFunction}>
                      {measurementNameShort + " "}
                      {
                        thereIsUpdatedVariable ?
                        <span style={{fontSize: '4px', fontWeight: 500, letterSpacing: '0.5px',
                          color: '#fff', backgroundColor: 'rgb(0, 100, 0)', padding: '3px 4px 2px', marginLeft: '1px', borderRadius: '10px' }}>UPDATED</span>:
                        undefined
                      }
                    </Typography>
                  </Box>
                  <Box style={{width: '60%', marginRight: '-25%'}}>
                    <Box className={classes.buttonContainer}>
                      {
                      isSizeWheel && !useTriggerPresentationNumber ?
                      <Box className={classes.measurementValueTextContainer} style={{
                        scale: reductionMode ? '1.1' : undefined,
                        width: reductionMode ? '40%' : undefined,
                      }}>
                        <SizeWheelComponent  
                          sizeNamesArray={sizeWheelDict?.[itemKey as ClothingMeasurementsKey]?.sizeNamesArray ?? []} 
                          sizeValuesArray={sizeWheelDict?.[itemKey as ClothingMeasurementsKey]?.sizeValuesArray ?? []} 
                          currentValue={sizeWheelDict?.[itemKey as ClothingMeasurementsKey]?.currentValue ?? 10} 
                          clothMeasName={sizeWheelDict?.[itemKey as ClothingMeasurementsKey]?.clothMeasName ?? 'ax'} />
                      </Box>:
                      <Box className={classes.measurementValueTextContainer}>
                        <Typography className={classes.measurementValueText}>
                          {measurementValue} cm
                        </Typography>
                        {/* <Typography className={classes.measurementValueTextSub} style={{fontSize: useTriggerPresentationNumber ? '7.8px' : undefined}}>
                          {useTriggerPresentationNumber ? "Pengaturan Manual" : currentClothingMeasSubtextDict?.[itemKey as ClothingMeasurementsKey]}
                        </Typography> */}
                      </Box>
                      }
                    </Box>
                  </Box>
                </Box>
                :
              <Grid container className={classes.measurementValueContainer}>
                <Grid item xs={7}>
                  <Typography className={classes.measurementNameText}
                  onClick={useTriggerAction ? triggerList[itemKey].triggerCallback : clothMeasActionsDict?.[itemKey].clothMeasInfoFunction}>
                    {measurementName + " "}
                    {
                      useTriggerAction ? 
                      <span className={classes.measurementNameTextIIcon}
                      style={{padding: '4px 9px 2px', backgroundColor: 'rgb(255, 255, 255)',
                        border: '1px solid rgb(100,100,100)',
                        borderRadius: '10px',
                        fontSize: '8px',
                        letterSpacing: '0.6px',
                      }}
                      onClick={triggerList[itemKey].triggerCallback}>
                        <EditIcon style={{height: '8px', width: '8px'}}/>
                        {` ${triggerList[itemKey].triggerText}`}
                      </span> : 
                      <span className={classes.measurementNameTextIIcon}>&#x24D8;</span>
                    }
                    {
                      currentClothingMeasUpdatedDict?.[itemKey] ?
                      <span style={{fontSize: '4px', fontWeight: 500, letterSpacing: '0.5px',
                        color: '#fff', backgroundColor: 'rgb(0, 100, 0)', padding: '3px 4px 2px', marginLeft: '3px', borderRadius: '10px' }}>UPDATED</span>:
                      undefined
                    }
                  </Typography>
                </Grid>
                <Grid item xs={5}>
                  <Box className={classes.buttonContainer}>
                    <Button onClick={clothMeasActionsDict?.[itemKey].minusDetail.onClickFunction}
                    disabled={!allowEditing || currentlyFetchingAvailability || !clothMeasActionsDict?.[itemKey].minusDetail.isEnabled}
                    style={{
                      color: 
                      allowEditing && clothMeasActionsDict?.[itemKey].minusDetail.isEnabled ? 
                      '#232323': 
                      '#efefef',
                      position: 'relative'
                    }}
                    className={classes.measurementChangeValueButton}>
                      -
                      {clothMeasActionsDict?.[itemKey].minusDetail.needsMod ? 
                        <img src={'https://studiosclo.uk/general/icon-uk-favorit-mod.png'}
                        style={{
                          width: '0.5rem',
                          position: 'absolute',
                          left: '1.2rem',
                          top: '0.1rem',
                        }}
                        alt={'uk-favorit-mod-min'}
                        /> : null}
                    </Button>
                    {
                      isSizeWheel && !useTriggerPresentationNumber ? 
                      <Box className={classes.measurementValueTextContainer} style={{
                        scale: reductionMode ? '1.1' : undefined,
                        width: reductionMode ? '40%' : undefined,
                      }}>
                        <SizeWheelComponent  
                          sizeNamesArray={sizeWheelDict?.[itemKey as ClothingMeasurementsKey]?.sizeNamesArray ?? []} 
                          sizeValuesArray={sizeWheelDict?.[itemKey as ClothingMeasurementsKey]?.sizeValuesArray ?? []} 
                          currentValue={sizeWheelDict?.[itemKey as ClothingMeasurementsKey]?.currentValue ?? 10} 
                          clothMeasName={sizeWheelDict?.[itemKey as ClothingMeasurementsKey]?.clothMeasName ?? 'ax'} />
                        <Typography className={classes.measurementValueTextSub} style={{marginTop: '6.2px', fontSize: '7.8px', letterSpacing: '0.04px', visibility: reductionMode ? 'hidden' : undefined}}>
                          Hasil Baju {measurementValue} cm
                        </Typography>
                      </Box>:
                      <Box className={classes.measurementValueTextContainer}>
                        <Typography className={classes.measurementValueText}>
                          {measurementValue} cm
                        </Typography>
                        <Typography className={classes.measurementValueTextSub} style={{letterSpacing: '0.06px', fontSize: useTriggerPresentationNumber ? '7.8px' : undefined}}>
                          {useTriggerPresentationNumber ? "Pengaturan Manual" : currentClothingMeasSubtextDict?.[itemKey as ClothingMeasurementsKey]}
                        </Typography>
                      </Box>
                    }
                    <Button onClick={clothMeasActionsDict?.[itemKey].plusDetail.onClickFunction}
                    disabled={!allowEditing || currentlyFetchingAvailability || !clothMeasActionsDict?.[itemKey].plusDetail.isEnabled}
                    style={{
                      color: 
                      allowEditing && clothMeasActionsDict?.[itemKey].plusDetail.isEnabled ? 
                      '#232323' : 
                      '#efefef',
                      position: 'relative'
                    }}
                    className={classes.measurementChangeValueButton}>
                      +
                      {clothMeasActionsDict?.[itemKey].plusDetail.needsMod ? 
                        <img src={'https://studiosclo.uk/general/icon-uk-favorit-mod.png'}
                        style={{
                          width: '0.5rem',
                          position: 'absolute',
                          left: '1.2rem',
                          top: '0.1rem',
                        }}
                        alt={'uk-favorit-mod-plus'}
                        /> : null}
                    </Button>
                  </Box>
                </Grid>
              </Grid>
              }
            </Grid>
          )
        })
      }
    </Grid>);
  }

  return (
    <Grid container className={classes.gridContainer} style={useInstantATCView ? {width: '100%'} : undefined}
    direction="row" justifyContent="flex-start">
    {
      instantAtcViewMinimized === '1-minimized' && !allowEditing ?
      <>
      <Typography style={{fontSize: '7.5px', letterSpacing: '0.3px', fontWeight: 300, color: '#565656', margin: '0px 0px 8px', width: '100%', textAlign: 'center'}}>{(thereIsUpdatedVariable ? "DIUBAH ": "DIBUAT ")}  
        <span style={{textDecoration: 'underline', textUnderlineOffset: '2px'}}><i>{(updateTimestamp ? convertTimestampToDisplayString(updateTimestamp)?.toUpperCase() : '')}</i></span></Typography>
      </>:
      null
    }
    {
      ClothingMeasurementOrdering.map((itemKey) => {
        let combineLebarBaju = false;
        if (instantAtcViewMinimized === '1-minimized' && !allowEditing) {
          if (thereIsUpdatedVariable) { // THERE IS UPDATED VARIABLES
            if (!currentClothingMeasUpdatedDict?.[itemKey]) {
              return null;
            }
          } else { // NO UPDATED VARIABLE / FRESH
            if (!dictOfDisplayedMinimized?.[itemKey]) {
              return null;
            }
            // CHECK IF CHEST AND WAIST IS EQUAL
            combineLebarBaju = currentClothingMeas.lebarDadaBaju === currentClothingMeas.lebarPerutBaju;
            // SKIP IF CHEST AND WAIST IS EQUAL AND ITEMKEY IS LEBAR PERUT BAJU
            if (combineLebarBaju && itemKey === ClothingMeasurementsKey.lebarPerutBaju) {
              return null;
            }
          }
        }
        if (!clothingMeasurementsDisplayed.includes(itemKey as ClothingMeasurementsKey)) {
          return null;
        }
        if (currentClothingMeas[itemKey as ClothingMeasurementsKey] === undefined) {
          return null;
        }
        if (ClothingMeasurementDetailList[itemKey as ClothingMeasurementsKey] === undefined
          || ClothingMeasurementAdjustmentLevel[itemKey as ClothingMeasurementsKey] === undefined
          || ClothingMeasurementAdjustmentLevel[itemKey as ClothingMeasurementsKey] === "unavailable") {
          return null;
        }

        let chosenBodyMeasKey: BodyMeasurementsKey | undefined = undefined;
        for (let bodyMeasKey of Object.keys(ClothBodyToDisplayedClothMeasForClothingTypeAndFitType[clothingType])) {
          if (ClothBodyToDisplayedClothMeasForClothingTypeAndFitType[clothingType]?.[bodyMeasKey as BodyMeasurementsKey]
             === itemKey) {
            chosenBodyMeasKey = bodyMeasKey as BodyMeasurementsKey;
          }
        }
        if (chosenBodyMeasKey === undefined) {
          return null;
        }

        const useTrigger = triggerList?.[(itemKey as string)] && triggerList?.[(itemKey as string)].bodyMeasurementsKey === chosenBodyMeasKey;
        const useTriggerAction = useTrigger && triggerList[itemKey].triggerText;
        const useTriggerPresentationNumber = (useTrigger && triggerList[itemKey].showMeasurementAs === "NUMBER")
          || ((clothingType === ClothingType.Body || usePersonalFitSpecificVariableDisplay) && dictOfClothingSpecificVariablesToBodyVariables[itemKey] && currentBodyMeasRawValue?.[dictOfClothingSpecificVariablesToBodyVariables[itemKey] as BodyMeasurementsKey]); // EITHER TRIGERRED ON CREATION OR SHOWN WHEN WE ARE USING BODY

        const measurementName = ClothingMeasurementDetailList[itemKey as ClothingMeasurementsKey].clothingMeasurementName;
        const measurementNameShort = (combineLebarBaju && itemKey === ClothingMeasurementsKey.lebarDadaBaju) ? "Lebar Baju" : ClothingMeasurementDetailList[itemKey as ClothingMeasurementsKey].clothingMeasurementNameShort;
        const measurementValue = currentClothingMeas[itemKey as keyof ClothingMeasurements] as number;
        return (
          <Grid item xs={12} >
            {
              useInstantATCView ? 
              <Box className={classes.measurementValueContainer} style={{
                height: '19px',
                display: 'flex',
                justifyContent: 'space-between',
                overflowX: 'hidden',
                overflowY: 'hidden',
              }}>
                <Box>
                  <Typography className={classes.measurementNameText} style={{color: '#454545', fontSize: '9px'}}
                  onClick={useTriggerAction ? triggerList[itemKey].triggerCallback : clothMeasActionsDict?.[itemKey].clothMeasInfoFunction}>
                    {measurementNameShort + " "}
                    {
                      thereIsUpdatedVariable ?
                      <span style={{fontSize: '5px', fontWeight: 500, letterSpacing: '0.5px',
                        color: '#fff', backgroundColor: 'rgb(0, 100, 0)', padding: '3px 5px 2px', marginLeft: '2px', borderRadius: '10px' }}>UPDATED</span>:
                      undefined
                    }
                  </Typography>
                </Box>
                <Box style={{width: '60%', marginRight: '-25%'}}>
                  <Box className={classes.buttonContainer}>
                    {
                    isSizeWheel && !useTriggerPresentationNumber ?
                    <Box className={classes.measurementValueTextContainer} style={{
                      scale: reductionMode ? '1.1' : undefined,
                      width: reductionMode ? '40%' : undefined,
                    }}>
                      <SizeWheelComponent  
                        sizeNamesArray={sizeWheelDict?.[itemKey as ClothingMeasurementsKey]?.sizeNamesArray ?? []} 
                        sizeValuesArray={sizeWheelDict?.[itemKey as ClothingMeasurementsKey]?.sizeValuesArray ?? []} 
                        currentValue={sizeWheelDict?.[itemKey as ClothingMeasurementsKey]?.currentValue ?? 10} 
                        clothMeasName={sizeWheelDict?.[itemKey as ClothingMeasurementsKey]?.clothMeasName ?? 'ax'} />
                    </Box>:
                    <Box className={classes.measurementValueTextContainer}>
                      <Typography className={classes.measurementValueText}>
                        {measurementValue} cm
                      </Typography>
                      {/* <Typography className={classes.measurementValueTextSub} style={{fontSize: useTriggerPresentationNumber ? '7.8px' : undefined}}>
                        {useTriggerPresentationNumber ? "Pengaturan Manual" : currentClothingMeasSubtextDict?.[itemKey as ClothingMeasurementsKey]}
                      </Typography> */}
                    </Box>
                    }
                  </Box>
                </Box>
              </Box>
              :
            <Grid container className={classes.measurementValueContainer}>
              <Grid item xs={7}>
                <Typography className={classes.measurementNameText}
                onClick={useTriggerAction ? triggerList[itemKey].triggerCallback : clothMeasActionsDict?.[itemKey].clothMeasInfoFunction}>
                  {measurementName + " "}
                  {
                    useTriggerAction ? 
                    <span className={classes.measurementNameTextIIcon}
                    style={{padding: '4px 9px 2px', backgroundColor: 'rgb(255, 255, 255)',
                      border: '1px solid rgb(100,100,100)',
                      borderRadius: '10px',
                      fontSize: '8px',
                      letterSpacing: '0.6px',
                    }}
                    onClick={triggerList[itemKey].triggerCallback}>
                      <EditIcon style={{height: '8px', width: '8px'}}/>
                      {` ${triggerList[itemKey].triggerText}`}
                    </span> : 
                    <span className={classes.measurementNameTextIIcon}>&#x24D8;</span>
                  }
                  {
                    currentClothingMeasUpdatedDict?.[itemKey] ?
                    <span style={{fontSize: '5px', fontWeight: 500, letterSpacing: '0.5px',
                      color: '#fff', backgroundColor: 'rgb(0, 100, 0)', padding: '3px 5px 2px', marginLeft: '3px', borderRadius: '10px' }}>UPDATED</span>:
                    undefined
                  }
                </Typography>
              </Grid>
              <Grid item xs={5}>
                <Box className={classes.buttonContainer}>
                  <Button onClick={clothMeasActionsDict?.[itemKey].minusDetail.onClickFunction}
                  disabled={!allowEditing || currentlyFetchingAvailability || !clothMeasActionsDict?.[itemKey].minusDetail.isEnabled}
                  style={{
                    color: 
                    allowEditing && clothMeasActionsDict?.[itemKey].minusDetail.isEnabled ? 
                    '#232323': 
                    '#efefef',
                    position: 'relative'
                  }}
                  className={classes.measurementChangeValueButton}>
                    -
                    {clothMeasActionsDict?.[itemKey].minusDetail.needsMod ? 
                      <img src={'https://studiosclo.uk/general/icon-uk-favorit-mod.png'}
                      style={{
                        width: '0.5rem',
                        position: 'absolute',
                        left: '1.2rem',
                        top: '0.1rem',
                      }}
                      alt={'uk-favorit-mod-min'}
                      /> : null}
                  </Button>
                  {
                    isSizeWheel && !useTriggerPresentationNumber ? 
                    <Box className={classes.measurementValueTextContainer} style={{
                      scale: reductionMode ? '1.1' : undefined,
                      width: reductionMode ? '40%' : undefined,
                    }}>
                      <SizeWheelComponent  
                        sizeNamesArray={sizeWheelDict?.[itemKey as ClothingMeasurementsKey]?.sizeNamesArray ?? []} 
                        sizeValuesArray={sizeWheelDict?.[itemKey as ClothingMeasurementsKey]?.sizeValuesArray ?? []} 
                        currentValue={sizeWheelDict?.[itemKey as ClothingMeasurementsKey]?.currentValue ?? 10} 
                        clothMeasName={sizeWheelDict?.[itemKey as ClothingMeasurementsKey]?.clothMeasName ?? 'ax'} />
                      <Typography className={classes.measurementValueTextSub} style={{marginTop: '6.2px', fontSize: '7.8px', letterSpacing: '0.04px', visibility: reductionMode ? 'hidden' : undefined}}>
                        Hasil Baju {measurementValue} cm
                      </Typography>
                    </Box>:
                    <Box className={classes.measurementValueTextContainer}>
                      <Typography className={classes.measurementValueText}>
                        {measurementValue} cm
                      </Typography>
                      <Typography className={classes.measurementValueTextSub} style={{letterSpacing: '0.06px', fontSize: useTriggerPresentationNumber ? '7.8px' : undefined}}>
                        {useTriggerPresentationNumber ? "Pengaturan Manual" : currentClothingMeasSubtextDict?.[itemKey as ClothingMeasurementsKey]}
                      </Typography>
                    </Box>
                  }
                  <Button onClick={clothMeasActionsDict?.[itemKey].plusDetail.onClickFunction}
                  disabled={!allowEditing || currentlyFetchingAvailability || !clothMeasActionsDict?.[itemKey].plusDetail.isEnabled}
                  style={{
                    color: 
                    allowEditing && clothMeasActionsDict?.[itemKey].plusDetail.isEnabled ? 
                    '#232323' : 
                    '#efefef',
                    position: 'relative'
                  }}
                  className={classes.measurementChangeValueButton}>
                    +
                    {clothMeasActionsDict?.[itemKey].plusDetail.needsMod ? 
                      <img src={'https://studiosclo.uk/general/icon-uk-favorit-mod.png'}
                      style={{
                        width: '0.5rem',
                        position: 'absolute',
                        left: '1.2rem',
                        top: '0.1rem',
                      }}
                      alt={'uk-favorit-mod-plus'}
                      /> : null}
                  </Button>
                </Box>
              </Grid>
            </Grid>
            }
          </Grid>
        )
      })
    }
    {
      (allowEditing) ? 
        <Grid item xs={12} style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          marginTop: '26px'
        }}>
          <img src={'https://studiosclo.uk/general/uk-favorit-keterangan.png'}
          alt={'uk-favorit-keterangan'}
          style={{ width: '90%' }}/> 
        </Grid>:
        null
    }
    {
      instantAtcViewMinimized === '1-minimized' && !allowEditing ?
      <Typography style={{fontSize: '7.6px', letterSpacing: '0.1px', margin: '4px 0px 8px', textDecoration: 'underline', textUnderlineOffset: '3px', width: '100%', textAlign: 'center'}} onClick={() => instantAtcViewMinimizedChange('2-complete')}>+ LIHAT DETAIL</Typography>:
      null
    }
  </Grid>
  );
}

export interface Props {
  startingClothingMeasurements: ClothingMeasurements
  startingClothingBodyMeasurements: BodyMeasurements
  editedClothingMeasurements?: ClothingMeasurements
  editedClothingBodyMeasurements?: BodyMeasurements
  clothingType: ClothingType
  fitType: FitType
  key2: string
  handleSubmit: (value: BodyMeasurements, valueClothing: ClothingMeasurements) => void
  productId?: string
  productDetail?: any
  isMinimized?: boolean
  showNumberOfSimiliarProduct?: boolean
  numberOfSimiliarProduct?: number
  onlyUseServiceability?: boolean
  allowSubmitWithoutChange?: boolean
  useBodyExtendedMeasRange?: boolean
  submitText?: string
  useSizeWheel?: boolean
}

export default function RegularModifySize({startingClothingMeasurements, startingClothingBodyMeasurements, editedClothingMeasurements, editedClothingBodyMeasurements, clothingType, fitType, key2, handleSubmit, productId, productDetail, isMinimized=false, useSizeWheel=false, showNumberOfSimiliarProduct, numberOfSimiliarProduct, onlyUseServiceability, allowSubmitWithoutChange, useBodyExtendedMeasRange, submitText}: Props) {
  const dispatch = useAppDispatch();
  const classes = useStyles({isMinimized: isMinimized})();
  const theme = useTheme();
  const isMdOrUp = useMediaQuery(theme.breakpoints.up("sm"));

  // console.log({startingClothingMeasurements, startingClothingBodyMeasurements, editedClothingMeasurements, editedClothingBodyMeasurements, clothingType, fitType, key2, handleSubmit, productId, productDetail, isMinimized, showNumberOfSimiliarProduct, numberOfSimiliarProduct})

  const [currentRawClothingMeas, setCurrentRawClothingMeas] = React.useState<ClothingMeasurements>(startingClothingMeasurements);
  const [currentClothingMeas, setCurrentClothingMeas] = React.useState<ClothingMeasurements>(startingClothingMeasurements);
  const [currentClothingBodyMeas, setCurrentClothingBodyMeas] = React.useState<BodyMeasurements>(startingClothingBodyMeasurements);
  const [followingClothingBodyMeas, setFollowingClothingBodyMeas] = React.useState<BodyMeasurementsKey[]>(DefaultFollowingMeasurementsForClothingTypeAndFitType[key2]);

  const [drawGuidelinesData, setDrawGuidelinesData] = React.useState<DrawGuidelinesData | undefined>(undefined);

  const [currentlyFetchingAvail, setCurrentlyFetchingAvail] = React.useState<boolean>(false);
  const [lastFetchStatus, setLastFetchStatus] = React.useState<string>('TOFETCH');
  const [nextMeasDict, setNextMeasDict] = React.useState<any>({});

  const cartProductList = useAppSelector(state => state.cart.cartProductList);
  const userBodyMeasurementsDict = useAppSelector(state => state.userMeasurementsList.userBodyMeasurementsDictionary);
  const userClothingMeasurementsDict =  useAppSelector(state => state.userMeasurementsList.userClothingMeasurementsDictionary);
  const productsDictionary = useAppSelector(state => state.productsList.productsDictionary);

  // Change Feature
  const [changesDetected, setChangesDetected] = React.useState(false);

  const handleReset = () => {
    setCurrentRawClothingMeas(startingClothingMeasurements);
    setCurrentClothingMeas(startingClothingMeasurements);
    setCurrentClothingBodyMeas(startingClothingBodyMeasurements);
    setFollowingClothingBodyMeas(DefaultFollowingMeasurementsForClothingTypeAndFitType[key2]);
    setChangesDetected(false);
    setDrawGuidelinesData(undefined);

    updateClothingMeasurement(startingClothingBodyMeasurements, DefaultFollowingMeasurementsForClothingTypeAndFitType[key2], '', undefined);
  };

  useEffect(() => {
    const hasChanges = 
      JSON.stringify(currentClothingMeas) !== JSON.stringify(startingClothingMeasurements) ||
      JSON.stringify(currentClothingBodyMeas) !== JSON.stringify(startingClothingBodyMeasurements);
    setChangesDetected(hasChanges);
  }, [currentClothingMeas, currentClothingBodyMeas]);


  function updateClothingMeasurement(
    newClothingBodyMeasurements: BodyMeasurements, 
    lastFollowingList: BodyMeasurementsKey[],
    originalHash: string,
    completeAdjustment: any,
  ) {
    // If there's no original hash, we assume this is a "forced" update and 
    if (!originalHash) {
      setNextMeasDict({}); // Since the original is very "far" from the current measurement, we disable the measurements first.
      getCurrentProposedSizeAvailability(newClothingBodyMeasurements, lastFollowingList);
      return;
    }

    if (hash(currentClothingBodyMeas) === originalHash) {
      getCurrentProposedSizeAvailability(newClothingBodyMeasurements, lastFollowingList);
    } else {
      // NOTE 
      // Effectively removes the "switching" bug, since the new adjustment is combined with the previous (fetching)
      // adjustment. If there is slow / no connectivity, however, this would only work "once" per variable until the 
      // request returns, since the plus / minus adjustments are NOT updated until the response arrives from the server.
      // There is an inherent tradeoff: If each step is "provided" by the server, we reach better continuity / consistency,
      // but if the internet is slow there will be some "lag". If we do local, there is risk, but much faster. 
      getCurrentProposedSizeAvailability({
        ...currentClothingBodyMeas,
        ...completeAdjustment
      }, lastFollowingList);
    }
  }

  useEffect(() => {
    getCurrentProposedSizeAvailability(startingClothingBodyMeasurements, DefaultFollowingMeasurementsForClothingTypeAndFitType[key2]);
    if (editedClothingMeasurements) {
      setCurrentRawClothingMeas(editedClothingMeasurements);
      setCurrentClothingMeas(editedClothingMeasurements);
    }
    if (editedClothingBodyMeasurements) {
      setCurrentClothingBodyMeas(editedClothingBodyMeasurements)
    }
  }, []);

  async function getCurrentProposedSizeAvailability(proposedClothBodyMeasurements: BodyMeasurements, lastFollowingList: BodyMeasurementsKey[]) {
    if (proposedClothBodyMeasurements) {
      // setCurrentlyFetchingAvail(true);
  
      let measurementsForItem: BodyMeasurements = proposedClothBodyMeasurements;
      let clothMeasurementsForItem: ClothingMeasurements = CalculateClothingMeasurementsFromBodyMeasurements(clothingType, fitType, proposedClothBodyMeasurements, RegularSizeValue.L);
      setCurrentRawClothingMeas(clothMeasurementsForItem);
      setCurrentClothingMeas(RoundClothingMeasurementsToHalfPoint(clothMeasurementsForItem));
      setCurrentClothingBodyMeas(measurementsForItem);
  
      const measPolicy: any = {};
      for (let measKey of Object.keys(measurementsForItem)) {
        measPolicy[measKey] = "EXACT";
      }

      let config: AxiosRequestConfig = { }

      if (useBodyExtendedMeasRange && productId) {
        config = {
          method: 'post',
          url: 'https://i3fxe6nvj7.execute-api.ap-southeast-1.amazonaws.com/prod/availability/meas-serviceable',
          data: JSON.stringify(
            {
              isFastServiceabilityCheck: true,
              measurements: measurementsForItem,
              constructRules: CreateBodyContructRangeForKey2(clothingType, fitType),
              measRules: GlobalMeasRules,
              productId: productId,
            })
        };
      } else if (productId) {

        var requestDataProducts: any = getRequestDataProducts(cartProductList, userBodyMeasurementsDict, userClothingMeasurementsDict);
        requestDataProducts.push({
          resource: "PRODUCT",
          resourceId: productId, 
          provisionStrategy: "PRODUCT",
          provisionStrategyMetadata: {
            productId: productId,
            measurements: measurementsForItem,
            measurementsPolicy: measPolicy,
          }
        });
  
        config = {
          method: 'post',
          url: 'https://i3fxe6nvj7.execute-api.ap-southeast-1.amazonaws.com/prod/availability',
          data: JSON.stringify(
            {
              "requestData": requestDataProducts,
            })
        };
      } else {
        config = {
          method: 'post',
          url: 'https://i3fxe6nvj7.execute-api.ap-southeast-1.amazonaws.com/prod/availability/meas-serviceable',
          data: JSON.stringify(
            {
              clothingType: clothingType,
              fitType: fitType,
              // Stand-in product for this key2, used when the backend has no mapped product for it.
              referenceProductId: getReferenceProductIdForKey2(productsDictionary, clothingType, fitType),
              measurements: measurementsForItem,
              measurementsPolicy: measPolicy
            })
        };
      }

      retryGetRequest(config, 8).then((response) => {
        setCurrentlyFetchingAvail(false);
        if (response?.data?.provisionStatus) {
          setLastFetchStatus(response?.data?.provisionStatus);
        }
        if (response?.data?.additionalRequestResultData?.changeMeasurementsDict
          && response?.data?.additionalRequestResultData?.measurementsResult) {
          const nextMeasDict: any = {};

          const changeMeasurementsDict: any = response.data.
            additionalRequestResultData.changeMeasurementsDict; // This is in BodyMeas space
          const originalClothBodyMeas: any = response.data.
            additionalRequestResultData.measurements;
          const resultClothBodyMeas: any = response.data.
            additionalRequestResultData.measurementsResult;
          const hashResultClothBodyMeas: string = hash(resultClothBodyMeas);

          if (hash(resultClothBodyMeas) !== hash(originalClothBodyMeas)) {
            updateClothingMeasurement(resultClothBodyMeas, lastFollowingList, '', undefined);
            setLastFetchStatus("ENOUGH");
            return;
          }

          for (let bodyMeasName of Object.keys(changeMeasurementsDict)) {
            const bodyMainAdj = Object.keys(changeMeasurementsDict[bodyMeasName].mainAdjustment)[0];
            const bodyMainAdjValueOriginal = resultClothBodyMeas[bodyMainAdj];
            const bodyMainAdjValue = changeMeasurementsDict[bodyMeasName].mainAdjustment[bodyMainAdj];
            const isServiceable = changeMeasurementsDict[bodyMeasName].isServiceable;
            const modAdjustment = changeMeasurementsDict[bodyMeasName].modAdjustment;

            const displayClothChangeKey = ClothBodyToDisplayedClothMeasForClothingTypeAndFitType[clothingType]?.[bodyMainAdj as BodyMeasurementsKey];

            if (displayClothChangeKey === undefined) {
              continue;
            }

            const changeIsPlus = bodyMainAdjValue > bodyMainAdjValueOriginal;

            const completeAdjustment = {
              [bodyMainAdj]: bodyMainAdjValue,
            }

            const newClothBodyMeas = {
              ...resultClothBodyMeas,
              [bodyMainAdj]: bodyMainAdjValue
            }
            if (modAdjustment) {
              for (let measKey of Object.keys(modAdjustment)) {
                newClothBodyMeas[measKey] = modAdjustment[measKey]
                completeAdjustment[measKey] = modAdjustment[measKey]
              }
            }

            // We remove the current changed main adjustment from the "following" list
            const newFollowingList = lastFollowingList.filter((value) => value.toString() !== bodyMainAdj);

            const newClothBodyMeasAfterFollowing = CalculateClothBodyMeasurementsFromBodyMeasurements(clothingType, fitType, 
              newClothBodyMeas, RegularSizeValue.L, newFollowingList);

            // We need is serviceable, if there is a mod adjustable needed, and the next clothing measurements
            nextMeasDict[displayClothChangeKey + (changeIsPlus ? "Plus" : "Minus")] = {
              isServiceable: isServiceable,
              modAdjustment: modAdjustment,
              needsMod: modAdjustment ? true : false,
              nextClothingBodyMeas: newClothBodyMeasAfterFollowing,
              nextFollowingClothingBodyMeas: newFollowingList,
              completeAdjustment: completeAdjustment,
              hashOriginalClothingBodyMeas: hashResultClothBodyMeas,
            };
          }
          setNextMeasDict(nextMeasDict);
        }
      });
    }
  }

  const key2ClothSizeValues = GetKey2CategoryClothingSizeMeasurementValues(clothingType, fitType, false);
  const subtextDict = getClothingMeasurementsSubtext(clothingType, key2ClothSizeValues, currentClothingMeas);
  const sizeRulerDict = getClothingMeasurementsRuler(clothingType, key2ClothSizeValues, currentRawClothingMeas);

  const currentRawClothingMeasBody = CalculateClothingMeasurementsFromBodyMeasurements(ClothingType.Body, FitType.RegularFit, currentClothingBodyMeas, RegularSizeValue.L);
  const currentClothingMeasBody = RoundClothingMeasurementsToHalfPoint(currentRawClothingMeasBody);
  const key2ClothSizeValuesBody = GetKey2CategoryClothingSizeMeasurementValues(ClothingType.Body, FitType.RegularFit, false);
  const subtextDictBody = getClothingMeasurementsSubtext(ClothingType.Body, key2ClothSizeValuesBody, currentClothingMeasBody);
  const sizeRulerDictBody = getClothingMeasurementsRuler(ClothingType.Body, key2ClothSizeValuesBody, currentRawClothingMeasBody);

  const inputClothMeasActionsDict: {[key:string]: {
    clothMeasInfoFunction: () => void
    minusDetail: {
      onClickFunction: () => void
      isEnabled: boolean
      needsMod: boolean
    }
    plusDetail: {
      onClickFunction: () => void
      isEnabled: boolean
      needsMod: boolean
    }
  }} = {};
  const clothingMeasurementsDisplayed = Object.values(ClothBodyToDisplayedClothMeasForClothingTypeAndFitType[clothingType]);
  for (let i = 0; i < ClothingMeasurementOrdering.length; i++) {
    const itemKey = ClothingMeasurementOrdering[i];
    if (!clothingMeasurementsDisplayed.includes(itemKey as ClothingMeasurementsKey)) {
      continue;
    }
    if (currentClothingMeas[itemKey as ClothingMeasurementsKey] === undefined) {
      continue;
    }
    if (ClothingMeasurementDetailList[itemKey as ClothingMeasurementsKey] === undefined
      || ClothingMeasurementAdjustmentLevel[itemKey as ClothingMeasurementsKey] === undefined
      || ClothingMeasurementAdjustmentLevel[itemKey as ClothingMeasurementsKey] === "unavailable") {
      continue;
    }

    const measurementName = ClothingMeasurementDetailList[itemKey as ClothingMeasurementsKey].clothingMeasurementName;

    const itemObject: {
      clothMeasInfoFunction: () => void
      minusDetail: {
        onClickFunction: () => void
        isEnabled: boolean
        needsMod: boolean
      }
      plusDetail: {
        onClickFunction: () => void
        isEnabled: boolean
        needsMod: boolean
      },
    } = {
      clothMeasInfoFunction: () => {dispatch(openOverlay(itemKey as ClothingMeasurementsKey))},
      minusDetail: {
        onClickFunction: () => {
          if (nextMeasDict?.[itemKey + "Minus"]?.isServiceable) {
            setFollowingClothingBodyMeas(nextMeasDict[itemKey + "Minus"].nextFollowingClothingBodyMeas);
            updateClothingMeasurement(nextMeasDict[itemKey + "Minus"].nextClothingBodyMeas, nextMeasDict[itemKey + "Minus"].nextFollowingClothingBodyMeas, nextMeasDict[itemKey + "Minus"].hashOriginalClothingBodyMeas, nextMeasDict[itemKey + "Minus"].completeAdjustment);

            // UPDATE GUIDELINES DATA
            const newDrawGuidelinesData: DrawGuidelinesData = {
              lastChangedMeasurement: itemKey,
              lastChangedMeasurementName: measurementName,
              guidelineDisplayRange: ClothingMeasurementAdjustmentDisplayRange[itemKey as ClothingMeasurementsKey],
              sizeMeasurementValues: key2ClothSizeValues.regularSizeClothMeasValues,
              sizeMeasurementNames: key2ClothSizeValues.regularSizeNames,
            }
            setDrawGuidelinesData(newDrawGuidelinesData);
          }
        },
        isEnabled: nextMeasDict?.[itemKey + "Minus"]?.isServiceable,
        needsMod: nextMeasDict?.[itemKey + "Minus"]?.needsMod,
      },
      plusDetail: {
        onClickFunction: () => {
          if (nextMeasDict?.[itemKey + "Plus"]?.isServiceable) {
            setFollowingClothingBodyMeas(nextMeasDict[itemKey + "Plus"].nextFollowingClothingBodyMeas);
            updateClothingMeasurement(nextMeasDict[itemKey + "Plus"].nextClothingBodyMeas, nextMeasDict[itemKey + "Plus"].nextFollowingClothingBodyMeas, nextMeasDict[itemKey + "Plus"].hashOriginalClothingBodyMeas, nextMeasDict[itemKey + "Plus"].completeAdjustment);

            // UPDATE GUIDELINES DATA
            const newDrawGuidelinesData: DrawGuidelinesData = {
              lastChangedMeasurement: itemKey,
              lastChangedMeasurementName: measurementName,
              guidelineDisplayRange: ClothingMeasurementAdjustmentDisplayRange[itemKey as ClothingMeasurementsKey],
              sizeMeasurementValues: key2ClothSizeValues.regularSizeClothMeasValues,
              sizeMeasurementNames: key2ClothSizeValues.regularSizeNames,
            }
            setDrawGuidelinesData(newDrawGuidelinesData);
          }
        },
        isEnabled: nextMeasDict?.[itemKey + "Plus"]?.isServiceable,
        needsMod: nextMeasDict?.[itemKey + "Plus"]?.needsMod,
      },
    };

    inputClothMeasActionsDict[itemKey] = itemObject;
  }


  let children: JSX.Element[] = [];
  let submitChildren: JSX.Element[] = [];

  children.push(
    <OverlayComponentBaseContainerHorizontal>
      <OverlayComponentBaseContainerWidth
        widthMdUp="100%"
        widthSmDown="100%">
        <Grid container>
          <Grid item xs={12}
            style={{
              display: 'flex',
              justifyContent: 'center',
          }}>
            {
              isMinimized && productDetail?.name ? 
              <Typography className={classes.ukuranCustomAvailText} style={{
                fontWeight: 600,
                fontSize: '14px',
                textAlign: 'center',
                marginBottom: '-10px',
                marginTop: '40px'
              }}>
                Produk {productDetail?.name}
              </Typography>:
              undefined
            }
          </Grid>
          {
            showNumberOfSimiliarProduct && numberOfSimiliarProduct && numberOfSimiliarProduct > 0 ? (
              <Grid container style={{
                width: '95%',
                padding: '7px 15px 5px 15px',
                borderRadius: '6vw',
                marginLeft: '10px',
                marginTop: '150px',
                marginBottom: '5px',
                border: '1px solid #eaeaea'
              }} justifyContent='space-between' alignItems='center'>
                <Typography
                  style={{
                    fontSize: '13px',
                    letterSpacing: '0.2px',
                    fontWeight: 500
                  }}
                >
                  {ClothingTypeDisplayString[clothingType as ClothingType].toUpperCase()}
                </Typography>
                <Typography
                  style={{
                    fontSize: '11px',
                    fontWeight: 600,
                    letterSpacing: '0.5px',
                    color: '#B0B0B0'
                  }}
                >
                  {numberOfSimiliarProduct} PRODUK
                </Typography>
    
              </Grid>
            ) : (
              null
            )
          }
          <Grid item xs={12}
            style={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '10px',
              marginBottom: isMdOrUp ? '40px' : '20px',
            }}>
            {
              onlyUseServiceability ? 
              undefined :
              currentlyFetchingAvail ?
              <Typography className={classes.ukuranCustomAvailText}
              style={{
                color: '#33ae33'
              }}>
                Bahan Tersedia Untuk Ukuran Ini
              </Typography>:
              lastFetchStatus === "ENOUGH" ?
              <Typography className={classes.ukuranCustomAvailText}
              style={{
                color: '#33ae33'
              }}>
                Bahan Tersedia Untuk Ukuran Ini
              </Typography>:
              lastFetchStatus === "NOTENOUGH" ?
              <Typography className={classes.ukuranCustomAvailText}
              style={{
                color: 'orange'
              }}>
                Bahan Tidak Cukup Untuk Ukuran Ini
              </Typography>:
              productId ? 
              <Typography className={classes.ukuranCustomAvailText}
              style={{
                color: '#454545'
              }}>
                Loading...
              </Typography>:
              undefined
            }
          </Grid>
          <Grid item xs={(isMdOrUp && !isMinimized) ? 6 : 12}
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              // paddingBottom: isMdOrUp ? '100px' : undefined
            }}
          >
            <Box className={classes.canvasContainer} style={isMinimized ? {height: '100%'} : {height: '250px', maxWidth: '250px'}}>
              <OverlayComponentCanvas
                clothingType={clothingType}
                fitType={fitType}
                putAtTop={false}
                scaleRatio={isMinimized ? 0.8 : 0.75}
                incrementTogether={true}
                goalFit={currentClothingMeas}
                drawGuidelinesData={drawGuidelinesData}
              />
              <IconButton
              style={{
                visibility: drawGuidelinesData ? 'visible' : 'hidden',
                backgroundColor: '#232323',
                color: '#ffffff',
                position: 'absolute',
                right: '0px',
                bottom: '20px',
                padding: '7px'
              }}
              onClick={() => {
                setDrawGuidelinesData(undefined);
              }} aria-label="zoom-out">
                <ZoomOutIcon />
              </IconButton>
              {
                isMdOrUp && (
                  <Grid item xs={12} style={{display: "flex", justifyContent: "center", alignItems: "center", marginBottom: '30px'}}>
                    <Button 
                      disabled={!changesDetected}>
                      <Box 
                        onClick={handleReset} 
                        style={{
                          border: '1px solid #717171',
                          borderColor: changesDetected ? 'black' : 'lightgrey',
                          borderRadius: '20px',
                          marginTop: '5px',
                          padding: '4px 13px 4px 13px',
                          color: changesDetected ? 'black' : 'lightgrey',
                          display: "flex", 
                          justifyContent: "center", 
                          alignItems: "center",
                          gap: '10px'
                      }}>
                        <RestoreIcon 
                          style={{
                            fontSize: '20px'
                          }}
                        />
                        <Typography
                            style={{
                              color: changesDetected ? '#262626' : 'lightgrey',
                              cursor: changesDetected ? 'pointer' : 'default',
                              fontSize: '10px',
                              letterSpacing: '0.5px',
                              fontWeight: 600,
                              paddingTop: '4px'
                            }}
                          >
                            KEMBALI KE UKURAN AWAL
                        </Typography>
                      </Box>
                    </Button>
                  </Grid>
                )
              }
            </Box>
          </Grid>
          <Grid item xs={(isMdOrUp && !isMinimized) ? 6 : 12} style={{
            paddingBottom: '20px',
          }}> 
            <Grid container>
              {
                !isMdOrUp && (
                  <Grid item xs={12} style={{display: "flex", justifyContent: "center", alignItems: "center", marginBottom: '10px'}}>
                    <Button 
                      disabled={!changesDetected}>
                      <Box 
                        onClick={handleReset} 
                        style={{
                          border: '1px solid #717171',
                          borderColor: changesDetected ? 'black' : 'lightgrey',
                          borderRadius: '20px',
                          marginTop: '5px',
                          padding: '4px 13px 4px 13px',
                          color: changesDetected ? 'black' : 'lightgrey',
                          display: "flex", 
                          justifyContent: "center", 
                          alignItems: "center",
                          gap: '10px'
                      }}>
                        <RestoreIcon 
                          style={{
                            fontSize: '20px'
                          }}
                        />
                        <Typography
                            style={{
                              color: changesDetected ? '#262626' : 'lightgrey',
                              cursor: changesDetected ? 'pointer' : 'default',
                              fontSize: '10px',
                              letterSpacing: '0.5px',
                              fontWeight: 600,
                              paddingTop: '4px'
                            }}
                          >
                            KEMBALI KE UKURAN AWAL
                        </Typography>
                      </Box>
                    </Button>
                  </Grid>
                )
              }
              <Grid item xs={12} 
              style={{
                display: isMdOrUp && !isMinimized? 'block' : 'flex',
                justifyContent: isMdOrUp && !isMinimized? 'flex-start' : 'center',
              }}>
                <ClothingMeasurementDetailPanel
                  clothingType={clothingType}
                  fitType={fitType}
                  allowEditing={true}
                  currentClothingMeas={currentClothingMeas}
                  currentClothingMeasSubtextDict={useSizeWheel ? subtextDictBody : subtextDict} // WE ALTERNATE: IF IT IS USED AS A BODY CREATION FEATURE, USE THE SUBTEXT BODY.
                  currentlyFetchingAvailability={currentlyFetchingAvail}
                  clothMeasActionsDict={inputClothMeasActionsDict}
                  isMinimized={isMinimized}
                  isSizeWheel={useSizeWheel}
                  sizeWheelDict={useSizeWheel ? sizeRulerDictBody : undefined}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </OverlayComponentBaseContainerWidth>
    </OverlayComponentBaseContainerHorizontal>
  );
  submitChildren.push(
    <OverlayComponentBaseContainerHorizontal
    alignItems='flex-end' >
      <Box>
        <Button
          onClick={() => {
            handleSubmit(currentClothingBodyMeas, currentClothingMeas);
          }}
          disabled={allowSubmitWithoutChange !== true && !changesDetected}
          style={{
            padding: '7px 25px 4.5px 25px',
            borderRadius: '20px',
            fontSize: '10.5px',
            fontWeight: 600,
            color: 'white',
            letterSpacing: '0.75px',
            backgroundColor: changesDetected || allowSubmitWithoutChange === true ? 'black' : 'lightgrey',
            margin: '10px 15px 20px 0px'
          }}
        >
          {submitText ? submitText : "SIMPAN"}
        </Button>
      </Box>
    </OverlayComponentBaseContainerHorizontal>
  );

  return (
    <OverlayComponentBaseTemplate alignItems="flex-start">
      <Box
        style={isMinimized ?
          {
            width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center'
          } : {

          }}
      >
        {/* <OverlayComponentTitle text="Sesuaikan ukuran dengan baju favorit kamu!" /> */}
        <Box>
          {
            children
          }
        </Box>
      </Box>
      <Box style={{ width: '100%' }}>
        {
          submitChildren
        }
      </Box>
      <PageProductOverlayMeasureInstructions />
    </OverlayComponentBaseTemplate>
  );
}